import { render, staticRenderFns } from "./voiceService.vue?vue&type=template&id=2b33aa7f&scoped=true"
import script from "./voiceService.vue?vue&type=script&lang=js"
export * from "./voiceService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33aa7f",
  null
  
)

export default component.exports